export default __webpack_public_path__ + "static/media/forbidden-price.a6d43bc4.svg";